import TIM from 'tim-js-sdk'
import { TUICallEngine, TUICallEvent, TUICallType } from 'tuicall-engine-webrtc'
import { genTestUserSig } from '../../public/debug/GenerateTestUserSig'
// 视频通话 type= 2 要摄像头
// 语音通话 type= 1 要麦克风

export function createTUICallEngine() {
  const tim = TIM.create({
    SDKAppID: genTestUserSig().sdkAppID,
  })

  const tuiCallEngine = TUICallEngine.createInstance({
    SDKAppID: genTestUserSig().sdkAppID,
  })
  return {
    tim,
    tuiCallEngine,
    TUICallEvent,
    TUICallType,
    genTestUserSig,
  }
}
